import React, {useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../actions/auth';
import  { GetSponsorsByCourse }  from '../../controllers/GetSponsorsByCourse';
import  { GetCourseInfo }  from '../../controllers/GetCourseInfo';
import { Navbar } from '../../components/ui/NavBar';
import {encode as base64_encode} from 'base-64';

// Home to display "Unidades"
export const SponsorScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const cursoId = localStorage.getItem('courseId');
    const [course, setCourse] = useState([]);
    const [list, setList] = useState([]);
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [cursoNombre, setCursoNombre] = useState('');
    const cursoColor = localStorage.getItem('courseColor');
    const courseName = localStorage.getItem('courseName');

    let ran = false;
    useEffect(() => {
        // console.log({ran})
        if (ran) return;
        //let data = GetCourseFather(cursoId, user.languaje, token);
        GetSponsorsByCourse(cursoId, user.languaje, token)
        .then((e)=>{
            if(e.status === "Token is Expired"){
                dispatch(logout(token));
            }
            // console.log(cursoId)
            // console.log(e)
            setList(e);
        })
        .catch((e)=>{
            console.error(e);
            //dispatch(logout(token));
         });

        GetCourseInfo(cursoId, user.languaje, token, user.id)
        .then((e)=>{
            setCourse(e[0]);
            setCursoNombre(e[0].name)
        })
        .catch((e)=>{
            console.error(e);
            //dispatch(logout(token));
        });
        return () => (ran = true);
    }, [cursoId])

    if(cursoId===''){
        history.replace('/home');
    }

    const disCourse = ()=>{
        let lists = list;
        // console.log('list',list)
        let group = 0;
        return lists.map((sponsor, idx) => (
            
            (sponsor.group_order === group)?
            <img key={sponsor.id} className="img-sponsor-course" src = {`data:image/svg+xml;base64,${base64_encode(sponsor.icon)}`} alt="Sponsor"/>
            :<React.Fragment key={idx}>
                <div style={{display: 'none',}}>{group = sponsor.group_order}</div>
                <div className="sponsor-text">
                    <span>{sponsor.group_text}</span>
                </div>   
                <img key={sponsor.id} className="img-sponsor-course" src = {`data:image/svg+xml;base64,${base64_encode(sponsor.icon)}`} alt="Sponsor"/>
             
                </React.Fragment>   
                ));
        
    }
    
    return (

            <div className="fund-main-unit-q">
            <Navbar title={courseName}/>
            <div className="text-title"
            style={{
                backgroundColor: cursoColor,
                color:  "#ffffff",
            }}
            >Entidades que hacen {courseName && courseName}</div>
                {
                    course && (course.background_home_type==="svg")
                    ?
                    <img key="entk" className="fund-start-b-imgu" src = {`data:image/svg+xml;base64,${base64_encode(course.background_home)}`} alt="Back Ground"/>
                    :
                    null
                }
                {/* <div className="sponsors-course">Las entidades ejecutoras del proyecto son:</div> */}
                
                <div className='content-sponsors'>
                {list && disCourse() }
                </div>
            </div>
    )
}

